module.exports = __webpack_public_path__ + "img/cashback.6a4fa359.svg";